import {
  fetchTrainingAndOwnerships,
  fetchTrainingAndOwnershipsArea,
  fetchTrainingAndOwnershipsRole,
  updateRoleAreaStatus,
  updateRoleAreaElementStatus,
  updateRoleAreaElementSignees,
  updateAreaElementStatus,
  updateAreaElementSignees,
  updateRoleAreaLinkState,
} from '../services/trainingAndOwnershipsService';

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// async thunk
export const requestTrainingAndOwnerships = createAsyncThunk(
  'trainingAndOwnerships/requestTrainingAndOwnerships',
    async () => {
        const response = await fetchTrainingAndOwnerships();
        return response.data;
    }
);

export const requestTrainingRoleData = createAsyncThunk(
  'trainingAndOwnerships/requestTrainingRoleData',
  async () => {
    const response = await fetchTrainingAndOwnershipsRole();
    return response.data;
  }
);

export const requestTrainingAreaData = createAsyncThunk(
  'trainingAndOwnerships/requestTrainingAreaData',
    async () => {
        const response = await fetchTrainingAndOwnershipsArea();
        return response.data;
    }
);

export const requestOwnedAreaData = createAsyncThunk(
    'trainingAndOwnerships/requestOwnedAreaData',
    async () => {
        const response = await fetchTrainingAndOwnershipsArea();
        return response.data;
    }
);

export const changeRoleAreaStatus = createAsyncThunk(
  'trainingAndOwnerships/changeRoleAreaStatus',
    async ({ roleId, areaId, status }) => {
        const response = await updateRoleAreaStatus(roleId, areaId, status);
        return response.data;
    }
);

export const changeRoleAreaLinkState = createAsyncThunk(
  'trainingAndOwnerships/changeRoleAreaLinkState',
    async ({ roleId, areaId, linkState }) => {
        const response = await updateRoleAreaLinkState(roleId, areaId, linkState);
        return response.data;
    }
);

export const changeRoleAreaElementStatus = createAsyncThunk(
  'trainingAndOwnerships/changeRoleAreaElementStatus',
    async ({ roleId, areaId, elementId, status }) => {
        const response = await updateRoleAreaElementStatus(roleId, areaId, elementId, status);
        return response.data;
    }
);

export const changeRoleAreaElementSignees = createAsyncThunk(
  'trainingAndOwnerships/changeRoleAreaElementSignees',
    async ({ roleId, areaId, elementId, signees }) => {
        const response = await updateRoleAreaElementSignees(roleId, areaId, elementId, signees);
        return response.data;
    }
);

export const changeAreaElementStatus = createAsyncThunk(
  'trainingAndOwnerships/changeAreaElementStatus',
    async ({ areaId, elementId, status }) => {
        const response = await updateAreaElementStatus(areaId, elementId, status);
        return response.data;
    }
);

export const changeAreaElementSignees = createAsyncThunk(
  'trainingAndOwnerships/changeAreaElementSignees',
    async ({ areaId, elementId, signees }) => {
        const response = await updateAreaElementSignees(areaId, elementId, signees);
        return response.data;
    }
);

export const updatedDashboardData = createAsyncThunk(
  'trainingAndOwnerships/updatedDashboardData',
  async (payload) => {
    const response = await updateDashboardData(payload);
    return response.data;
  }
);

export const taoUpdatedPersonElementData = createAsyncThunk(
  'trainingAndOwnerships/taoUpdatedPersonElementData',
    async ({ personId, elementId, status }) => {
        const response = await updatePersonElementData(personId, elementId, status);
        return response.data;
    }
);

export const updatedDashboardPersonData = createAsyncThunk(
  'trainingAndOwnerships/updatedDashboardPersonData',
  async (payload) => {
    const response = await updateDashboardPersonData(payload);
    return response.data;
  }
);

const trainingAndOwnershipsSlice = createSlice({
  name: 'trainingAndOwnerships',
  initialState: {
    knowledgeRoles: {},
    knowledgeAreas: {},
    knowledgeElements: {},
    trainingRoles: {},
    trainingKnowledgeAreas: {},
    ownedRoles: {},
    ownedKnowledgeAreas: {},
    persons: {},
    selectedSidebarElement: {
      id: null,
      type: null,
    },
    hasOverviewLoaded: false,
  },
  reducers: {
    setSelectedSidebarElement: (state, action) => {
      state.selectedSidebarElement = {
        id: action.payload.id,
        type: action.payload.type,
      };
    },
    setTrainingRoleLoader: (state, action) => {
      const { id, isLoading, hasLoaded } = action.payload;
      if (!state.trainingRoles[id]) {
        state.trainingRoles[id] = {};
      }
      state.trainingRoles[id].isLoading = isLoading;
      state.trainingRoles[id].hasLoaded = hasLoaded;
    },
    setTrainingRoleErrorMsg: (state, action) => {
      const { id, errorMsg } = action.payload;
      if (!state.trainingRoles[id]) {
        state.trainingRoles[id] = {};
      }
      state.trainingRoles[id].errorMsg = errorMsg;
    },
    setOwnedRoleLoader: (state, action) => {
      const { id, isLoading, hasLoaded } = action.payload;
      if (!state.ownedRoles[id]) {
        state.ownedRoles[id] = {};
      }
      state.ownedRoles[id].isLoading = isLoading;
      state.ownedRoles[id].hasLoaded = hasLoaded;
    },
    setOwnedRoleErrorMsg: (state, action) => {
      const { id, errorMsg } = action.payload;
      if (!state.ownedRoles[id]) {
        state.ownedRoles[id] = {};
      }
      state.ownedRoles[id].errorMsg = errorMsg;
    },
    setTrainingAreaLoader: (state, action) => {
      const { id, isLoading, hasLoaded } = action.payload;
      if (!state.trainingKnowledgeAreas[id]) {
        state.trainingKnowledgeAreas[id] = {};
      }
      state.trainingKnowledgeAreas[id].isLoading = isLoading;
      state.trainingKnowledgeAreas[id].hasLoaded = hasLoaded;
    },
    setTrainingAreaErrorMsg: (state, action) => {
      const { id, errorMsg } = action.payload;
      if (!state.trainingKnowledgeAreas[id]) {
        state.trainingKnowledgeAreas[id] = {};
      }
      state.trainingKnowledgeAreas[id].errorMsg = errorMsg;
    },
    setOwnerAreaLoader: (state, action) => {
      const { id, isLoading, hasLoaded } = action.payload;
      if (!state.ownedKnowledgeAreas[id]) {
        state.ownedKnowledgeAreas[id] = {};
      }
      state.ownedKnowledgeAreas[id].isLoading = isLoading;
      state.ownedKnowledgeAreas[id].hasLoaded = hasLoaded;
    },
    setOwnerAreaErrorMsg: (state, action) => {
      const { id, errorMsg } = action.payload;
      if (!state.ownedKnowledgeAreas[id]) {
        state.ownedKnowledgeAreas[id] = {};
      }
      state.ownedKnowledgeAreas[id].errorMsg = errorMsg;
    },
    updatedPersonElementDataReceived: (state, action) => {
      const { personId, elementId, status, completedAt, hasValidity, daysUntilExpiration } = action.payload;
      if (state.persons[personId] && state.persons[personId].knowledgeElements) {
        state.persons[personId].knowledgeElements[elementId] = {
          ...state.persons[personId].knowledgeElements[elementId],
          status,
          completedAt,
          hasValidity,
          daysUntilExpiration,
        };
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestTrainingAndOwnerships.pending, (state) => {
        state.hasOverviewLoaded = false;
      })
      .addCase(requestTrainingAndOwnerships.fulfilled, (state, action) => {
        Object.assign(state, action.payload);
        state.hasOverviewLoaded = true;
      })
      .addCase(requestTrainingAndOwnerships.rejected, (state) => {
        state.hasOverviewLoaded = false;
      })
      .addCase(requestTrainingRoleData.pending, (state, action) => {
        const id = action.meta.arg;
        if (!state.trainingRoles[id]) {
          state.trainingRoles[id] = {};
        }
        state.trainingRoles[id].isLoading = true;
        state.trainingRoles[id].hasLoaded = false;
        state.trainingRoles[id].errorMsg = null;
      })
      .addCase(requestTrainingRoleData.fulfilled, (state, action) => {
        const { id, data } = action.payload;
        state.persons = addPersonsToState(state.persons, data);
        
        state.trainingRoles[id] = {
          ...state.trainingRoles[id],
          ...data.role,
          isLoading: false,
          hasLoaded: true,
        };
        
        state.knowledgeAreas = {
          ...state.knowledgeAreas,
          ...data.knowledgeAreas,
        };
        
        state.knowledgeElements = {
          ...state.knowledgeElements,
          ...data.knowledgeElements,
        };
      })
      .addCase(requestTrainingRoleData.rejected, (state, action) => {
        const id = action.meta.arg;
        if (!state.trainingRoles[id]) {
          state.trainingRoles[id] = {};
        }
        state.trainingRoles[id].isLoading = false;
        state.trainingRoles[id].hasLoaded = false;
        state.trainingRoles[id].errorMsg = 'Failed getting data for role';
      })
      .addCase(requestOwnedAreaData.pending, (state, action) => {
        const id = action.meta.arg;
        if (!state.ownedKnowledgeAreas[id]) {
          state.ownedKnowledgeAreas[id] = {};
        }
        state.ownedKnowledgeAreas[id].isLoading = true;
        state.ownedKnowledgeAreas[id].hasLoaded = false;
        state.ownedKnowledgeAreas[id].errorMsg = null;
      })
      .addCase(requestOwnedAreaData.fulfilled, (state, action) => {
        const { id, data } = action.payload;
        state.persons = addPersonsToState(state.persons, data);
        
        state.ownedKnowledgeAreas[id] = {
          ...state.ownedKnowledgeAreas[id],
          ...data.area,
          isLoading: false,
          hasLoaded: true,
        };
        
        state.knowledgeRoles = {
          ...state.knowledgeRoles,
          ...data.knowledgeRoles,
        };
        
        state.knowledgeElements = {
          ...state.knowledgeElements,
          ...data.knowledgeElements,
        };
      })
      .addCase(requestOwnedAreaData.rejected, (state, action) => {
        const id = action.meta.arg;
        if (!state.ownedKnowledgeAreas[id]) {
          state.ownedKnowledgeAreas[id] = {};
        }
        state.ownedKnowledgeAreas[id].isLoading = false;
        state.ownedKnowledgeAreas[id].hasLoaded = false;
        state.ownedKnowledgeAreas[id].errorMsg = 'Failed getting data for area';
      })
      .addCase(requestTrainingAreaData.pending, (state, action) => {
        const id = action.meta.arg;
        if (!state.trainingKnowledgeAreas[id]) {
          state.trainingKnowledgeAreas[id] = {};
        }
        state.trainingKnowledgeAreas[id].isLoading = true;
        state.trainingKnowledgeAreas[id].hasLoaded = false;
        state.trainingKnowledgeAreas[id].errorMsg = null;
      })
      .addCase(requestTrainingAreaData.fulfilled, (state, action) => {
        const { id, data } = action.payload;
        state.persons = addPersonsToState(state.persons, data);
        
        state.trainingKnowledgeAreas[id] = {
          ...state.trainingKnowledgeAreas[id],
          ...data.area,
          isLoading: false,
          hasLoaded: true,
        };
        
        state.knowledgeRoles = {
          ...state.knowledgeRoles,
          ...data.knowledgeRoles,
        };
        
        state.knowledgeElements = {
          ...state.knowledgeElements,
          ...data.knowledgeElements,
        };
      })
      .addCase(requestTrainingAreaData.rejected, (state, action) => {
        const id = action.meta.arg;
        if (!state.trainingKnowledgeAreas[id]) {
          state.trainingKnowledgeAreas[id] = {};
        }
        state.trainingKnowledgeAreas[id].isLoading = false;
        state.trainingKnowledgeAreas[id].hasLoaded = false;
        state.trainingKnowledgeAreas[id].errorMsg = 'Failed getting data for area';
      })
      .addCase(changeRoleAreaStatus.fulfilled, (state, action) => {
        const { personId, data } = action.payload;
        if (state.persons[personId]) {
          const updated = {
            persons: {
              [personId]: {
                knowledgeElements: data.persons[personId].knowledgeElements,
                knowledgeAreas: data.persons[personId].knowledgeAreas,
              }
            }
          };
          state.persons = addPersonsToState(state.persons, updated);
        }
      })
      .addCase(changeRoleAreaLinkState.fulfilled, (state, action) => {
        const { personId, data } = action.payload;
        if (state.persons[personId]) {
          const updated = {
            persons: {
              [personId]: {
                knowledgeElements: data.persons[personId].knowledgeElements,
                knowledgeAreas: data.persons[personId].knowledgeAreas,
              }
            }
          };
          state.persons = addPersonsToState(state.persons, updated);
        }
      })
      .addCase(changeRoleAreaElementStatus.fulfilled, (state, action) => {
        const { personId, data } = action.payload;
        if (state.persons[personId]) {
          const updated = {
            persons: {
              [personId]: {
                knowledgeElements: data.persons[personId].knowledgeElements,
                knowledgeAreas: data.persons[personId].knowledgeAreas,
              }
            }
          };
          state.persons = addPersonsToState(state.persons, updated);
        }
      })
      .addCase(changeRoleAreaElementSignees.fulfilled, (state, action) => {
        state.persons = addPersonsToState(state.persons, action.payload);
      })
      .addCase(changeAreaElementStatus.fulfilled, (state, action) => {
        const { personId, data } = action.payload;
        if (state.persons[personId]) {
          const updated = {
            persons: {
              [personId]: {
                knowledgeElements: data.persons[personId].knowledgeElements,
                knowledgeAreas: data.persons[personId].knowledgeAreas,
              }
            }
          };
          state.persons = addPersonsToState(state.persons, updated);
        }
      })
      .addCase(changeAreaElementSignees.fulfilled, (state, action) => {
        state.persons = addPersonsToState(state.persons, action.payload);
      })
      .addCase(taoUpdatedPersonElementData.fulfilled, (state, action) => {
        const { personId, elementId, status, completedAt, hasValidity, daysUntilExpiration } = action.payload;
        if (state.persons[personId] && state.persons[personId].knowledgeElements) {
          state.persons[personId].knowledgeElements[elementId] = {
            ...state.persons[personId].knowledgeElements[elementId],
            status,
            completedAt,
            hasValidity,
            daysUntilExpiration,
          };
        }
      });
  },
});

export const {
  setSelectedSidebarElement,
  setTrainingRoleLoader,
  setTrainingRoleErrorMsg,
  setOwnedRoleLoader,
  setOwnedRoleErrorMsg,
  setTrainingAreaLoader,
  setTrainingAreaErrorMsg,
  setOwnerAreaLoader,
  setOwnerAreaErrorMsg,
  updatedPersonElementDataReceived,
} = trainingAndOwnershipsSlice.actions;

export const trainingAndOwnershipsActions = {
  setSelectedSidebarElement,
  setTrainingRoleLoader,
  setTrainingRoleErrorMsg,
  setOwnedRoleLoader,
  setOwnedRoleErrorMsg,
  setTrainingAreaLoader,
  setTrainingAreaErrorMsg,
  setOwnerAreaLoader,
  setOwnerAreaErrorMsg,
  updatedPersonElementDataReceived,
};
export const requestOwnedRoleData = requestOwnedAreaData;
export default trainingAndOwnershipsSlice.reducer;


// helpers
const addKnowledgeAreasToPersonInState = (persons, personId, action) => {
  const personObj = Object.keys(action.data.persons[personId].knowledgeAreas).reduce((obj, key) => {
    if (persons[personId].knowledgeAreas[key]) {
      obj[key] = {
        ...action.data.persons[personId].knowledgeAreas[key],
        roles: {
          ...persons[personId].knowledgeAreas[key].roles,
          ...action.data.persons[personId].knowledgeAreas[key].roles,
        },
      };
    } else {
      obj[key] = { ...action.data.persons[personId].knowledgeAreas[key] };
    }
    return obj;
  }, {});
  return {
    ...persons[personId].knowledgeAreas,
    ...personObj,
  };
};

const addPersonsToState = (persons, action) => {
  const personObj = Object.keys(action.data.persons).reduce((obj, key) => {
    if (persons[key]) {
      obj[key] = {
        ...action.data.persons[key],
        knowledgeElements: {
          ...persons[key].knowledgeElements,
          ...action.data.persons[key].knowledgeElements,
        },
        knowledgeAreas: addKnowledgeAreasToPersonInState(persons, key, action),
      };
    } else {
      obj[key] = { ...action.data.persons[key] };
    }
    return obj;
  }, {});
  return {
    ...persons,
    ...personObj,
  };
};
